export const AUTO_LOGIN = "AUTO_LOGIN";
export const autoLogin = () => ({
  type: AUTO_LOGIN,
});

export const LOGIN_BEGIN = "LOGIN_BEGIN";
export const loginBegin = (email, password) => ({
  type: LOGIN_BEGIN,
  email,
  password,
});

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const loginSuccess = () => ({
  type: LOGIN_SUCCESS,
});

export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const loginFailure = () => ({
  type: LOGIN_FAILURE,
});
